import { render, staticRenderFns } from "./SsalesoderCreate.vue?vue&type=template&id=1081ff04&scoped=true"
import script from "./SsalesoderCreate.vue?vue&type=script&lang=js"
export * from "./SsalesoderCreate.vue?vue&type=script&lang=js"
import style0 from "./SsalesoderCreate.vue?vue&type=style&index=0&id=1081ff04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1081ff04",
  null
  
)

export default component.exports